/**
 * Search Service Factory - Creates appropriate search service instances
 *
 * This factory creates search service instances based on the requested type.
 * It supports 'mock', 'api', and 'meilisearch' service types.
 */

import { SearchService } from "../types";
import { ApiSearchService } from "./api-search-service";
import { MockSearchService } from "./searchService.ts";

/**
 * Create a search service instance
 *
 * @param type - Service type ('mock', 'api', 'meilisearch')
 * @param config - Service configuration
 * @returns SearchService instance
 */
export function createSearchService(type: "mock" | "api" | "meilisearch" = "mock", config: Record<string, unknown> = {}): SearchService {
	switch (type) {
		case "api":
			return new ApiSearchService(config);

		case "meilisearch":
			// For now, meilisearch also uses the API service (proxy)
			return new ApiSearchService(config);

		case "mock":
		default:
			return new MockSearchService();
	}
}

/**
 * Export all available service classes for direct use
 */
export { ApiSearchService, MockSearchService };
export type { SearchService };
